import React from "react"; 
import { Link } from "react-router-dom";    
import CreateCategoryForm from "./CreateCategoriesForm";

const CreateCategory = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Create Category</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>eCommerce</li>
          <li>Create Category</li>
        </ul>
      </div> */}

      <CreateCategoryForm />
    </>
  );
};

export default CreateCategory;
